import { render } from "./Stickers.vue?vue&type=template&id=002ddffa&scoped=true&ts=true"
import script from "./Stickers.vue?vue&type=script&lang=ts"
export * from "./Stickers.vue?vue&type=script&lang=ts"

import "./Stickers.vue?vue&type=style&index=0&id=002ddffa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002ddffa"]])

export default __exports__